import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Card, Popper, MenuItem, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from 'src/components/iconify';

import { TABLE_HEAD_TAGS } from '../table/TagTableHeaders';

function MainFilterPopper({
  filterPopover,
  setFilterName,
  setFilterBy,
  setSearchBy,
  selectedFilter,
  setSelectedFilter,
  handleCloseFilter,
  handleCloseSubFilter,
  setSubFilterPopover,
  setPage,
}) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  const handleOpenSubFilter = (event, category) => {
    if (category === 'department') {
      setSubFilterPopover({ department: event.currentTarget });
    } else if (category === 'createdBy') {
      setSubFilterPopover({ createdBy: event.currentTarget });
    }
  };
  return (
    <Popper
      open={Boolean(filterPopover)}
      anchorEl={filterPopover}
      placement="left-start"
      onClose={handleCloseFilter}
    >
      <Card
        sx={{
          p: 1,
          minwidth: 140,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            boxShadow: '0.5px 0.5px 2 px',
          },
        }}
      >
        {TABLE_HEAD_TAGS.filter(({ id }) => {
          // FIXED: Filter out search-by, metadata, and createdBy columns using the correct 'id' property
          if (
            [
              'id',
              'name',
              'description',
              'createdAt',
              'updatedAt',
              'actions',
              'options',
              'Options',
              'createdBy',
            ].includes(id)
          ) {
            return false;
          }
          return true;
        }).map(({ id }) =>
          id === 'department' ? (
            <MenuItem
              key={id}
              selected={selectedFilter === 'department'}
              onMouseEnter={(e) => handleOpenSubFilter(e, 'department')}
              onTouchStart={(e) => handleOpenSubFilter(e, 'department')}
              onClick={() => handleCloseSubFilter()}
            >
              <Iconify
                icon="eva:arrow-ios-back-outline"
                sx={{
                  mr: 1,
                  width: isSmallScreen ? 16 : 20,
                  height: isSmallScreen ? 16 : 20,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: isSmallScreen && '0.7rem',
                }}
              >
                {t('filters.byDepartment')}
              </Typography>
            </MenuItem>
          ) : (
            <MenuItem
              key={id}
              selected={selectedFilter === id}
              onMouseEnter={handleCloseSubFilter}
              onClick={() => {
                setFilterName('');
                setFilterBy(id === 'createdBy' ? 'createdBy.username' : id);
                setSearchBy(`by${id.charAt(0).toUpperCase() + id.slice(1)}`);
                setSelectedFilter(id);
                handleCloseFilter();
                handleCloseSubFilter();
                setPage(0);
              }}
              onTouchStart={() => {
                setFilterName('');
                setFilterBy(id);
                setSearchBy(`by${id.charAt(0).toUpperCase() + id.slice(1)}`);
                setSelectedFilter(id);
                handleCloseFilter();
                handleCloseSubFilter();
                setPage(0);
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: isSmallScreen && '0.7rem',
                }}
              >
                {id && t(`filters.by${id.charAt(0).toUpperCase() + id.slice(1)}`)}
              </Typography>
            </MenuItem>
          )
        )}
      </Card>
    </Popper>
  );
}

MainFilterPopper.propTypes = {
  filterPopover: PropTypes.object,
  setFilterName: PropTypes.func,
  setFilterBy: PropTypes.func,
  setSearchBy: PropTypes.func,
  selectedFilter: PropTypes.string,
  setSelectedFilter: PropTypes.func,
  handleCloseFilter: PropTypes.func,
  handleCloseSubFilter: PropTypes.func,
  setSubFilterPopover: PropTypes.func,
  setPage: PropTypes.func,
};

export default MainFilterPopper;
